import { generatePath } from 'react-router-dom'
import {
  PRODUCTS,
  PRODUCT_INFO,
  PRODUCT_UPDATE,
  PRODUCT_CREATE,
  PRODUCT_DELETE,
  PRODUCT_STOCK_LOG,
  PRODUCTS_DONWLOAD,
} from 'constants/api-paths'
import request from './request'
import { formatError } from './error'
import { parseToSaveProduct } from './parsers/product'

export const requestProductsList = async (page, filters) => {
  const params = page > 1 ? { params: { page, ...filters } } : { params: filters }

  return request.get(PRODUCTS, params)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))
}

export const requestProductsListDonwload = async (filters) => (
  request.get(PRODUCTS_DONWLOAD, { params: filters })
    .then((resp) => resp.data)
    .catch((error) => formatError(error))
)

export const requestSearchProduct = async (search) => (
  requestProductsList(0, { search, per: 10 })
)

export const requestProductInfo = async (id) => {
  const path = generatePath(PRODUCT_INFO, { id })

  return request.get(path)
    .then((resp) => resp.data)
    .catch((error) => {
      let message = 'Houve um erro ao buscar o produto'
      if (error?.response?.status === 404) {
        message = 'Produto não encontrado'
      }

      return formatError(error, message)
    })
}

export const requestProductUpdate = async (id, product) => {
  const path = generatePath(PRODUCT_UPDATE, { id })
  const params = parseToSaveProduct(product)

  return request.patch(path, params)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))
}

export const requestProductCreate = async (product) => {
  const params = parseToSaveProduct(product)

  return request.post(PRODUCT_CREATE, params)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))
}

export const requestProductDelete = async (id) => {
  const path = generatePath(PRODUCT_DELETE, { id })

  return request.delete(path)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))
}

export const requestProductStockLogs = async ({ id, page = 1 }) => {
  const path = generatePath(PRODUCT_STOCK_LOG, { id })
  const params = { page }

  return request.get(path, { params })
    .then((resp) => resp.data)
    .catch((error) => formatError(error))
}
